import * as React from 'react';
import { NavLink } from 'react-router-dom';
import { LeftArrowIcon } from './Icons';

export interface DescriptionWrapperProperties {
    previousPageTitle?: string;
    onPreviousPageLinkClick?: () => void;
    title: string;
    description: string | string[];
    descriptionAsReactFragment?: JSX.Element;
    warningDescription?: string;
    notes?: React.ReactFragment[];
}

export default abstract class DescriptionWrapper<T extends DescriptionWrapperProperties, U> extends React.Component<T, U> {
    constructor(props: any) {
        super(props);

        this.executePreviousPageLinkClick = this.executePreviousPageLinkClick.bind(this);
    }

    render() {
        return (
            <div className="container">
                <div className="row d-flex align-items-start align-items-lg-stretch content__container">
                    <aside className="col-12 col-lg-4 col-xl-4 d-flex flex-column flex-lg-row flex-lg-column justify-content-start justify-content-lg-between align-self-end align-self-lg-stretch">
                        <div className="d-flex align-items-center">
                            <div className="content__box">
                                <h1 className="title title--margin-top-small">
                                    {this.renderPreviousPageLink()}
                                    <br /> {this.props.title}
                                </h1>
                                <div className="subtitle dynamic__height">
                                    <div>
                                        {this.renderDescription()}
                                        {this.renderWarningDescription()}
                                        {this.renderDescriptionAsReactFragment()}
                                    </div>
                                    <ul>
                                        {this.renderNotes()}
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <span className="bottom__link">For more information look at our <a href="https://www.lucidlink.com/faq/" target="_blank">FAQ</a></span>
                    </aside>
                    {this.props.children}
                </div>
            </div>
        );
    }

    private renderDescriptionAsReactFragment(): JSX.Element | null {
        const description = this.props.descriptionAsReactFragment;
        if (!description) {
            return null;
        }
        return description as JSX.Element;
    }

    private renderDescription(): JSX.Element[] | string {
        const description: string[] | string = this.props.description;
        if (typeof description === 'string') {
            return description;
        }
        return description.map((item, idx) => {
            return (<p key={idx} dangerouslySetInnerHTML={{__html: item}}/>);
        });
    }

    private renderPreviousPageLink(): JSX.Element | null {
        if (this.props.previousPageTitle) { 
            return (
                <NavLink
                    to={'/'}
                    className="last-step"
                    onClick={this.executePreviousPageLinkClick}
                >
                    <LeftArrowIcon width="11px" height="10px" />
                    Back to the {this.props.previousPageTitle}
                </NavLink>
            ); 
        } else { 
            return null; 
        }
    }

    private executePreviousPageLinkClick(e: any): void {
        e.preventDefault();
        if (this.props.onPreviousPageLinkClick) {
            this.props.onPreviousPageLinkClick();
        }
    }

    private renderWarningDescription(): JSX.Element | null {
        if (this.props.warningDescription) { 
            return <span>{this.props.warningDescription}</span>; 
        } else { 
            return null; 
        }
    }

    private renderNotes(): JSX.Element[] | null {
        if (this.props.notes) {
            return this.props.notes.map((item, i) => {
                return <li key={i}>{item}</li>;
            });
        } else {
            return null; 
        }
    }
}



// WEBPACK FOOTER //
// ./src/webportal/components/common/DescriptionWrapper.tsx